import { createApp } from 'vue'
import KelimeSayisi from './KelimeSayisi.vue'
import './assets/global.css'

createApp(KelimeSayisi).mount('#kelime')
